<sc-sensor-grid *ngIf="tireSensors.length || tireLocations.length"
                [sensors]="tireSensors"
                [emptyLocations]="tireLocations"
                [selectedSensorId]="selectedSensorId"
                [hoveredSensorId]="hoveredSensorId"
                [showSteeringWheel]="showSteeringWheel"
                [assetType]="assetType"
                (sensorHover)="hoveredSensorId = $event"
                (sensorSelect)="onSensorTileSelect($event)"></sc-sensor-grid>
<div *ngIf="iconSensors.length" class="sensor-icon-group">
  <button type="button"
          class="sensor-icon-chip"
          *ngFor="let sensor of iconSensors"
          [ngClass]="sensorSeverityCssClass(sensor)"
          [class.selected]="sensor.sensorId === selectedSensorId"
          [class.hovered]="sensor.sensorId === hoveredSensorId"
          (mouseenter)="hoveredSensorId = sensor.sensorId"
          (mouseleave)="hoveredSensorId = null"
          [matTooltip]="sensor.sensorId"
          (click)="onSensorTileSelect(sensor)">
    <mat-icon class="sensor-icon-glyph">{{ sensorIcon(sensor) }}</mat-icon>
    <mat-icon class="sensor-icon-stale" *ngIf="isSensorStale(sensor)" [matTooltip]="'@staleTooltip' | translate">hourglass_empty</mat-icon>
  </button>
</div>
<div class="sensor-sort-bar" *ngIf="visibleSensors.length > 1">
  <button class="sort-pill"
          [class.active]="sensorsSortBy === 'location'"
          (click)="sortSensors('location')">
    {{ '@position' | translate }}
    <mat-icon *ngIf="sensorsSortBy === 'location'">{{ sensorsSortDesc ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
  </button>
  <button class="sort-pill"
          [class.active]="sensorsSortBy === 'severity'"
          (click)="sortSensors('severity')">
    {{ '@severity' | translate }}
    <mat-icon *ngIf="sensorsSortBy === 'severity'">{{ sensorsSortDesc ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
  </button>
  <button class="sort-pill"
          [class.active]="sensorsSortBy === 'date'"
          (click)="sortSensors('date')">
    {{ '@lastUpdate' | translate }}
    <mat-icon *ngIf="sensorsSortBy === 'date'">{{ sensorsSortDesc ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
  </button>
</div>
<div *ngIf="visibleSensors.length" class="sensor-list">
  <div class="sensor-card"
       [attr.data-sensor-id]="sensor.sensorId"
       *ngFor="let sensor of visibleSensors"
       [class.selected]="sensor.sensorId === selectedSensorId"
       [class.hovered]="sensor.sensorId === hoveredSensorId"
       (mouseenter)="hoveredSensorId = sensor.sensorId"
       (mouseleave)="hoveredSensorId = null"
       (click)="onSensorCardSelect(sensor)"
       role="button" tabindex="0"
       (keydown.enter)="onSensorCardSelect(sensor)">
    <div class="sensor-row">
      <span class="sensor-sev-dot"
            [ngClass]="sensorSeverityCssClass(sensor)"
            [matTooltip]="sensorSeverityKey(sensor) | translate"></span>
      <span class="sensor-id">
        {{ sensorLocationLabel(sensor) }}<span class="sensor-part-tag" *ngIf="sensorPartTag(sensor) as pt">{{ pt }}</span>
      </span>
      <mat-icon class="sensor-row-stale" *ngIf="isSensorStale(sensor)" [matTooltip]="'@staleTooltip' | translate">hourglass_empty</mat-icon>
    </div>
    <div class="sensor-value-row" *ngFor="let v of sensorValueRows(sensor)" [class.stale-reading]="isStaleReading(v)">
      <span class="sensor-value-type">
        {{ sensorValueTypeLabel(sensor, v) }}
        <span class="stale-tag" *ngIf="isStaleReading(v)">{{ '@stale' | translate }}</span>
      </span>
      <span class="sensor-value-sev" [ngClass]="sensorValueCssClass(v)">{{ sensorValueSeverityKey(v) | translate }}</span>
      <span class="sensor-value-reading">{{ v.sensorValue | sensorValue:v.sensorValueType }}</span>
      <span class="sensor-value-time"
            *ngIf="v.dataLastReceived"
            [matTooltip]="v.dataLastReceived | date:'medium'">
        {{ v.dataLastReceived | timeAgo }}
      </span>
    </div>
  </div>
</div>
